// src/encounter/intelligence/intel-rail-close.ts
//
// `?x=intel-rail-catalog`: what the screen hands Antonin's rail header and wrap-up link.
//   - Close Intelligence: main's one rail close (rail-close.ts, PROD-3388 `?x=intel-close`), the same context today's rail
//     reads; the screen that holds the rail provides it (the pre-visit, the started encounter's long page). No provider:
//     no Close button.
//   - Review and sign: the encounter shell's jump to the note's real Sign; no provider (the pre-visit, tests): no link.
// Kept apart from the components so a component file exports components only (react-refresh).
import { createContext } from 'react';

export { IntelligenceCloseContext as IntelRailCloseContext } from './rail-close';

/** Wrap-up's "Review and sign" (his rail link): the shell's jump to the note's real Sign, or none (no link is drawn). */
export const IntelRailSignContext = createContext<(() => void) | undefined>(undefined);
